import { FC } from "react";


const Login:FC = () => {
    return <div />
}

export default Login;